<sabis-ngx-dialog scTitle="Update Application">

  <div modal-body class="application-status">
    <sabis-combobox2 [(ngModel)]="selectedJobApplicationStatusId" [required]="true" [scItems]="jobApplicationStatuses"
      [disabled]="isSaving || isLoading || noSelection" name="newStatus" scLabel="New Status" scValueField="itemId"
    scDisplayField="itemName" (ngModelChange)="onApplicationStatusChanged()"></sabis-combobox2>

    <!-- reasons -->
    @if (selectedApplicationStatusReasons.length > 0) {
      <sabis-combobox2
        [(ngModel)]="selectedApplicationStatusReasonId" [required]="true" [scItems]="selectedApplicationStatusReasons"
        [disabled]="isSaving || isLoading || noSelection" name="statusReason" [scOrderBy]="['applicationStatusReasonId']"
        scLabel="Application Status Reason" scValueField="applicationStatusReasonId" scDisplayField="name"
      (ngModelChange)="onApplicationStatusReasonChange()"></sabis-combobox2>
    }

    <!-- comments -->
    <div class="sc-form-control sc-100">
      <sabis-ngx-textarea scLabel="Comments" name="comments" maxlength="4000" [(ngModel)]="comments"
      [required]="isCommentsRequired" [disabled]="isSaving || isLoading"></sabis-ngx-textarea>
    </div>

    <!--send email checkbox: if true ==> show email section-->
    @if (showSendEmail) {
      <sabis-ngx-checkbox [(ngModel)]="sendEmail" name="sendEmail" scLabel="Send Email" [disabled]="isSaving || isLoading">
      </sabis-ngx-checkbox>
    }

    <!-- email editor -->
    @if (sendEmail) {
      <div>
        <sca-email [email]="email" #emailForm [noTemplate]="false"
        [allowedEmailTemplateIds]="this.emailTemplatesIds"></sca-email>
      </div>
    }
  </div>

  <div modal-footer>
    <sabis-ngx-button (click)="onSaveButtonClick()" [disabled]="isSaving || isLoading">
      Save
    </sabis-ngx-button>
    <sabis-ngx-button (click)="onCloseButtonClick()">
      Close
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>
